import { useState } from "react";
import { api, ROUTES } from "./api";
import { useAdmin, useAsync, Field, ErrorState, Loading, PageHead } from "./ui";

export default function ContactInfo() {
  const { data, loading, error, reload } = useAsync(() => api.get(ROUTES.contactInfo));
  if (error) return <ErrorState error={error} onRetry={reload} />;
  if (loading || !data) return <Loading />;
  return <ContactForm initial={data} onSaved={reload} />;
}

function ContactForm({ initial, onSaved }) {
  const { toast } = useAdmin();
  const { addressLines, ...rest } = initial;
  const [f, setF] = useState({ ...rest, addressText: (addressLines || []).join("\n") });
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setF((s) => ({ ...s, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { addressText, ...fields } = f;
      const payload = {
        ...fields,
        addressLines: addressText.split(/\r?\n/).map((l) => l.trim()).filter(Boolean),
      };
      const form = new FormData();
      form.append("data", JSON.stringify(payload));
      await api.upload("PUT", ROUTES.contactInfo, form);
      toast("Contact page saved");
      onSaved();
    } catch (err) {
      toast(err.message, "err");
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <PageHead
        title="Contact page"
        sub="Edit everything shown on the Contact Us page"
        actions={<button className="btn primary" form="contact-form" disabled={saving}>{saving ? "Saving…" : "Save changes"}</button>}
      />
      <form id="contact-form" onSubmit={submit} className="form-grid">
        <Field label="Heading"><input className="input" value={f.heading} onChange={set("heading")} /></Field>
        <Field label="Sub heading"><input className="input" value={f.subheading} onChange={set("subheading")} /></Field>

        <Field label="Phone"><input className="input" value={f.phone} onChange={set("phone")} /></Field>
        <Field label="Phone hours"><input className="input" value={f.phoneHours} onChange={set("phoneHours")} /></Field>

        <Field label="Email"><input className="input" type="email" value={f.email} onChange={set("email")} /></Field>
        <Field label="Email note"><input className="input" value={f.emailNote} onChange={set("emailNote")} /></Field>

        <div className="span-2">
          <Field label="Address" hint="One line per row">
            <textarea className="input" rows="3" value={f.addressText} onChange={set("addressText")} />
          </Field>
        </div>
        <div className="span-2">
          <Field label="Map location" hint="Text Google Maps can search, for example an address or a place name">
            <input className="input" value={f.mapQuery} onChange={set("mapQuery")} />
          </Field>
        </div>
        <Field label="Form title"><input className="input" value={f.formTitle} onChange={set("formTitle")} /></Field>
      </form>
    </>
  );
}